<script>
import { mapGetters } from '../store'
export default {
    name: 'SettingsHome',
    components: {},
    computed: {
        ...mapGetters(['userResource'])
    },
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        
    },
    async mounted() {
        
    },
}
</script>

<template>
    <div v-if="!loading">
        <section class="py-md-5 gray">
            <b-container fluid>
                <b-row>
                    <b-col md="3" class="recruit-nav">
                        <div class="recruit-nav-inner section-heading mb-2">
                            <h4>{{ userResource }}</h4>
                            <p>Developer</p>
                            <hr class="mt-4" />
                            <ul class="list-unstyled">
                                <li><router-link :to="{ name: 'settingsGeneral' }"><b-icon icon="gear" /> General</router-link></li>
                                <li><router-link :to="{ name: 'settingsDeveloperProfilePreview' }"><b-icon icon="person" /> Profile</router-link></li>
                                <li><router-link :to="{ name: 'settingsChangePassword' }"><b-icon icon="shield" /> Change Password</router-link></li>
                                <li><router-link :to="{ name: 'settingsApps' }"><b-icon icon="file-earmark-text" /> Applications</router-link></li>
                            </ul>
                        </div>
                    </b-col>
                    <b-col>
                        <div class="recruit-router-inner p-4" v-if="userResource">
                            <router-view></router-view>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </section>
    </div>
</template>

<style lang="scss">

</style>
